(function($) {
    'use strict';

    $(window).on('elementor/frontend/init', function() {
        elementorFrontend.hooks.addAction('frontend/element_ready/dataserv-resource-cards.default', function(scope, $) {
            function resourcesSorting() {
                let $filtersWrapper = $('.resource--filters');

                if ($filtersWrapper.length >= 0) {
                    let $grid = $('.resource--cards');
                    let $filters = $('#tg_resource_industry_filter , #tg_resource_type_filter');

                    $grid.isotope({
                        filter: '*',
                        animationOptions: {
                            duration: 750,
                            easing: 'linear',
                            queue: false,
                        }
                    });

                    // Run Isotope filter on Resource type selection
                    if ($filters.length >= 0) {
                        $filters.on('change', function() {
                            let $values = [];
                            $filters.each( function(index, element) {
                                //Capture selected values from all choosers
                                $values.push($(element).val());
                            })
                            $values = $values.join('');
                            
                            $grid.isotope({
                                filter: $values ? $values : '*',
                                animationOptions: {
                                    duration: 750,
                                    easing: 'linear',
                                    queue: false,
                                }
                            });

                            return false;
                        })
                    }
                }
            }

            resourcesSorting();
        });
    });

})(jQuery);
